import { Component, OnInit, Input } from '@angular/core';

import { SharedFeaturedService } from './shared-featured.service';


@Component({
  selector: 'app-shared-featured',
  templateUrl: './shared-featured.component.html',
  styleUrls: ['./shared-featured.component.scss']
})
export class SharedFeaturedComponent implements OnInit {
  @Input() departmentType: any;

  /**
   * RETORNO API
   * errors: Coleção de erros com falhas vindo do servidor
   * message: Mensagem de falha/sucesso processada pela API
   * statusCode: Código da mensagem de falha/sucesso processada pela API
   * registers: Retorno da coleção de dados solicitados a API
   */
  errors: any[] = [];
  message: string;
  statusCode: number;
  registers: any;

  constructor(
    private sharedFeaturedService: SharedFeaturedService) { }

  ngOnInit(): void {
    this.featured();
  }

  /**
   * lastNews() - Buscar últimas notícias publicadas
   */
  featured() {
    this.sharedFeaturedService.getFeatured(this.departmentType)
        .subscribe(
        returnSuccess => { this.successCallbackApi(returnSuccess) },
        returnFail => { this.errorCallbackServer(returnFail) }
      );
  }

  /**
   * successCallbackApi: Retorna resultado da API
   * @param response 
   */
  successCallbackApi(response: any) {
    this.message = response.description;
    this.statusCode = response.status_code;
    this.registers = response.registers;
  }

  /**
   * errorCallbackServer: Retorna resultado de erros do servidor
   * @param fail 
   */
  errorCallbackServer(fail: any) {
    this.errors = fail.error.errors;
    this.statusCode = 1; // erro
    this.registers = null;
  }

}
